// extracted by mini-css-extract-plugin
export default {"departments":"fH-z","departmentHeading":"gH-z","departmentSection":"hH-z","departmentName":"iH-z","departmentLink":"jH-z","expandIcon":"kH-z"};